import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import DestinationsPage from './pages/Destinations';
import CountryDetailPage from './pages/CountryDetails';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Application from './pages/Application';
import ContactUs from './pages/ContactUs';
import About from './pages/About';
import Banner from './components/Banner';
import Services from './pages/Services';
import Continents from './pages/Continents';
import NotFound from './pages/NotFound';
import Blog from './pages/Blog';
import PostDetailsComponent from './components/PostDetails';

function App() {
  return (
    <div className="app-container">
      <Header />
      <main className=''>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/destinations" element={<DestinationsPage />} />
          <Route path="/destination/:countryCode" element={<CountryDetailPage />} />
          <Route path="/application" element={<Application />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/continents" element={<Continents />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<PostDetailsComponent />} />
          <Route path="*" element={<NotFound />} />
         
        </Routes>
      </main>
      <Banner />
      <Footer />
    </div>
  );
}

export default App;